const breakPoint = 767;
let resizeFlag = false;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = (type) => {

  $(document).ready(function(){
    let urlId = location.hash;

    let width = $(window).width();
    let headerHeight = 0;
    let scrollSpeed = 800;

    if(width < 1001) {
      headerHeight = $(".st-Header_Static").outerHeight();
    }else{
      if(type == "sub"){
        headerHeight = $("#st-Header_Fixed").outerHeight() + $("#sw-Submenu_Fixed").outerHeight();
      }else{
        headerHeight = $("#st-Header_Fixed").outerHeight();
      }
    }

    if(urlId) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        let loadTarget = $(urlId == "#" || urlId == "" ? 'html' : urlId).offset().top;
        toAnker(loadTarget,headerHeight,scrollSpeed);
      }, 100);
    }
    $('a[href^="#"]').on("click", function() {
      let linkHref = $(this).attr("href");
      let linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
      let linkPosition = linkTarget.offset().top;
      toAnker(linkPosition,headerHeight,scrollSpeed);
      return false;
    });
    const toAnker = (linkPosition,linkAdjust,linkSpeed) => {
      $("html, body").animate({
        scrollTop: linkPosition - linkAdjust
      }, linkSpeed, "swing");
    }
  })
};

// ------------------------------------------------------------------------
// headerSticky
// ----- BOTH
// ------------------------------------------------------------------------
const navSticky = (type) => {
  $(window).on("load resize", function() {
    const header = $("#st-Header_Fixed");
    const submenu = $("#sw-Submenu_Fixed");
    const addclass1 = 'header-sticky';
    const addclass2 = 'submenu-sticky';
    const scrollY = 200;
    let submenuPos = $('#sw-Submenu_Static').offset();
    if ($(window).scrollTop() > scrollY) {
      header.addClass(addclass1);
    } else {
      header.removeClass(addclass1);
    }
    $(window).scroll(function() {
      if ($(window).scrollTop() > scrollY) {
        header.addClass(addclass1);
      } else {
        header.removeClass(addclass1);
      }
    });
    if (type == "sub") {
      if ($(window).scrollTop() > submenuPos.top) {
        submenu.addClass(addclass2);
      } else {
        submenu.removeClass(addclass2);
      }
      $(window).scroll(function() {
        if ($(window).scrollTop() > submenuPos.top) {
          submenu.addClass(addclass2);
        } else {
          submenu.removeClass(addclass2);
        }
      });
    }
  });
};

// ------------------------------------------------------------------------
// spMenu
// ----- BOTH
// ------------------------------------------------------------------------
const spMenu = () => {
  let flag = 0;
  $('a.st-Header_Hamburger').on('click', function() {
    $(this).toggleClass("hamburger_close");
    if (flag == 0) {
      $(".st-Header_Slide").addClass("sp_menu_open");
      flag = 1;
    } else {
      $(".st-Header_Slide").removeClass("sp_menu_open");
      $(".st-Header_Slide").removeClass("sp_menu_place_open");
      $(".st-Header_Slide").removeClass("sp_menu_place_open").delay(300).queue(function(next) {
        $(this).removeClass("sp_menu_place_open_option");
        next();
      });
      flag = 0;
    }
  });
  $('.place_toggle').on('click', function() {
    if (flag == 0) {
      $(".st-Header_Slide").addClass("sp_menu_place_open_option");
      $('a.st-Header_Hamburger').addClass("hamburger_close");
      $(".st-Header_Slide").addClass("sp_menu_place_open");
      flag = 1;
    } else {
      $('a.st-Header_Hamburger').removeClass("hamburger_close");
      $(".st-Header_Slide").removeClass("sp_menu_open");
      $(".st-Header_Slide").removeClass("sp_menu_place_open").delay(300).queue(function(next) {
        $(this).removeClass("sp_menu_place_open_option");
        next();
      });
      flag = 0;
    }
  });
};

// ------------------------------------------------------------------------
// tabMenu
// ----- BOTH
// ------------------------------------------------------------------------
const tabMenu = () => {
  $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').on('click', function() {
    let index = $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').index(this);
    $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').removeClass('active');
    $(this).addClass('active');
    $('.pla-Contents_Timetable_Table').removeClass('current');
    $('.pla-Contents_Timetable_Table').eq(index).addClass('current');
  });
};

// ------------------------------------------------------------------------
// placeNav
// ----- BOTH
// ------------------------------------------------------------------------
const placeNav = () => {
  let count = 0;
  const delay = 500;
  $('.place_toggle,.st-Header_Place').mouseenter(function() {
    count++;
    $(".st-Header_Place").fadeIn(300);
  }).mouseleave(function() {
    count--;
    setTimeout(function() {
      if (!count) {
        $(".st-Header_Place").fadeOut(300);
      }
    }, delay);
  });
  $(window).scroll(function() {
    $(".st-Header_Place").fadeOut(300);
  });
};

// ------------------------------------------------------------------------
// scrollBar
// ----- BOTH
// ------------------------------------------------------------------------
const scrollBar = () => {
  $(window).on("load", function() {
    $(".sw-Fukubiki_Notice_Inner").mCustomScrollbar();
  });
};

// ------------------------------------------------------------------------
// modalPopup
// ----- BOTH
// ------------------------------------------------------------------------
const modalPopup = () => {
  $('.popup').magnificPopup({
  type:'image'
  });
};

// ------------------------------------------------------------------------
// modalPopup
// ----- BOTH
// ------------------------------------------------------------------------
const preLoad = () => {
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};


export {
  anchorLink,
  navSticky,
  spMenu,
  tabMenu,
  placeNav,
  scrollBar,
  modalPopup,
  preLoad
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js